module.exports = __webpack_public_path__ + "static/media/1. Muro, Resina cristal y tela, 240 x 180 cm, 2020 copy.c75c4273.png";